import { toast } from "react-toastify"
import Request from "./axiosInstance"
import { deleteCookies } from "../utils/util"

declare const window: any

const tokenInterceptor: any = Request.interceptors.request.use(
  req => {
    const token = localStorage.getItem("token")
    if (!!token) {
      req.headers["Authorization"] = `Token ${token}`
    }
    return req
  },
  null,
  { synchronous: true }
)

const responseInterceptor = Request.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    
    // If error is 401 and we haven't tried to refresh token yet
    if (error?.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      
      // Clear all auth data
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('company');
      deleteCookies();
      
      // Redirect to login
      window.location.href = '/login';
      return Promise.reject(error);
    }
    
    return Promise.reject(error);
  }
);

const catchErrors = (err:any) => {
  if ([400, 500, 403, 401].find(e => e == err?.response?.status)) {
    window?.customErrorCallback?.(
      err.response.data.message,
      err?.response?.status
    )
    if (err?.response?.status === 403) {
      toast.error('You do not have permission to perform this action.', { autoClose: 5000 })
    }
  }
  throw err;
};

window.addEventListener("storage", () => {
  if (!localStorage.getItem("token")) {
    Request.interceptors.response.eject(responseInterceptor);
  }
})

export const get = (url: string, config?: any) => {
  return Request.get(url, config).catch(catchErrors)
}

export const post = (url: string, data?: any, config?: any) => {
  return Request.post(url, data, config).catch(catchErrors)
}

export const put = (url: string, config: any) => {
  return Request.put(url, config).catch(catchErrors)
}

export const patch = (url: string, data: any, config?: any) => {
  return Request.patch(url, data, config).catch(catchErrors)
}

export const del = (url: string, config?: any) => {
  return Request.delete(url, config).catch(catchErrors)
}
